import { render, staticRenderFns } from "./LogoLargeCpt.vue?vue&type=template&id=572ddef2&"
import script from "./LogoLargeCpt.vue?vue&type=script&lang=ts&"
export * from "./LogoLargeCpt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports